/* Glambe: set / bundle buttons. They open our own COD form with the whole set (the bundle discount is applied inside the form and the Worker, no discount code).
   Covers the fixed sets (.gbb__btn), quiz sets, and the mix-and-match builder (.gbm__btn).
   If our form cannot open, the fallback is the plain cart page. */
(function () {
  if (window.__gbCod) return; window.__gbCod = 1;
  var busy = false;
  var PCT = { GLAMBEMIX15: 15, GLAMBEMIX25: 25, GLOWTRIO: 33, GLAMBE30: 30 };
  function parse(href) {
    var code = '', path = href, m = href.match(/^\/discount\/([^?]+)\?redirect=(.*)$/);
    if (m) { try { code = decodeURIComponent(m[1]); } catch (e) { code = m[1]; } path = m[2]; }
    var ids = path.replace(/^\/cart\//, '').split(',').filter(Boolean).map(function (s) { var p = s.split(':'); return { id: +p[0], quantity: +p[1] || 1 }; }).filter(function (x) { return x.id > 0; });
    return { code: code, items: ids };
  }
  function ourForm(job, fail) {
    if (!window.gbFormOpen) return false;
    var it = job.items;
    if (it.length === 1) {
      if (it[0].quantity > 3 || job.code) return false;
      window.gbFormOpen({ variantId: String(it[0].id), qty: it[0].quantity, tam: true, fail: fail });
      return true;
    }
    var key = job.code.toUpperCase();
    if (job.mix) key = it.length >= 3 ? 'GLAMBEMIX25' : 'GLAMBEMIX15';
    if (!PCT[key] || it.length > 5 || !it.every(function (x) { return x.quantity === 1; })) return false;
    window.gbFormOpen({ variantId: String(it[0].id), bundle: key, pct: PCT[key], tam: true, clearCart: true, fail: fail, items: it.map(function (x) { return { variantId: String(x.id) }; }) });
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-gb-cod],a.gbb__btn,a.gbm__btn,.gb-result__set a.gb-btn');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (a.classList.contains('is-off') || href === '#' || href === '') { e.preventDefault(); return; }
    var job = parse(href);
    if (!job.code && a.getAttribute('data-gb-code')) job.code = a.getAttribute('data-gb-code');
    job.mix = a.classList.contains('gbm__btn');
    if (!job.items.length) return;
    e.preventDefault();
    if (busy) return; busy = true;
    a.setAttribute('aria-busy', 'true'); a.style.opacity = '.75';
    function done() { busy = false; a.removeAttribute('aria-busy'); a.style.opacity = ''; }
    function fail() { done(); location.href = '/cart/' + job.items.map(function (x) { return x.id + ':' + x.quantity; }).join(','); }
    if (ourForm(job, fail)) { setTimeout(done, 600); return; }
    fail();
  });
})();
